import elements from '../store/elements'
import { state } from '../store/state'
import triggers from '../store/triggers'

const updateAmount = (imgIndex) => {
  const amount = elements.amounts[imgIndex].dataset.avalue
  if (amount === state.amount) return
  elements.amounts[imgIndex].parentElement.querySelector('input').checked = true
  state.amount = amount
  triggers.emitEvent('state:amount', [amount])
}

const amounts = () => {
  triggers.on('state:imgIndex', updateAmount)
}

export default amounts
